import { render, staticRenderFns } from "./CollectDetailLink.vue?vue&type=template&id=19fc17fb&scoped=true"
import script from "./CollectDetailLink.vue?vue&type=script&lang=js"
export * from "./CollectDetailLink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19fc17fb",
  null
  
)

export default component.exports